import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotComics() {
  const hotComics = comics.filter((c) => c.isHot);

  return (
    <section className="bg-background-950 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-block px-4 py-1.5 border border-white/20 rounded-full text-white/80 text-xs font-medium mb-4 whitespace-nowrap">
              热门推荐
            </span>
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-white">
              本周最受欢迎的
              <span className="block">韩国漫画</span>
            </h2>
          </div>
          <Link
            to="/category/all?sort=rating"
            className="text-white/60 hover:text-white text-sm flex items-center gap-1 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 -mx-4 px-4 md:px-6 scrollbar-thin">
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.slug}`}
              className="group flex-shrink-0 w-[180px] md:w-[220px] cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 韩国漫画无删减下拉式阅读`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2 flex gap-1.5">
                  <span className="px-2 py-0.5 bg-accent-500 text-white text-[10px] font-medium rounded-full whitespace-nowrap">
                    {comic.rating}
                  </span>
                  {comic.status === '连载中' && (
                    <span className="px-2 py-0.5 bg-primary-500 text-white text-[10px] font-medium rounded-full whitespace-nowrap">
                      连载
                    </span>
                  )}
                </div>
              </div>
              <h3 className="text-white font-medium text-sm mb-1 line-clamp-1">{comic.title}</h3>
              <p className="text-foreground-400 text-xs">{comic.author} · {comic.chapters}话</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}